import { ApiError, apiRequest } from './api';
import { t } from './language';
import type { ChatThreadDTO, ChatThreadDetailDTO } from '../shared/types';

/**
 * Sohbet geçmişi (migration 0056, docs/sohbet-gecmisi-plani.md): sunucudaki şifreli sohbetleri
 * listeler, açar, yeniden adlandırır ve siler. Başlık ve mesajlar sunucuda çözülür; istemci
 * kriptografi yapmaz. Uçlar henüz yoksa (eski sunucu) liste boş döner, sohbet bellekte sürer.
 */

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

function requireId(id: unknown): string {
  if (typeof id !== 'string' || !UUID.test(id)) throw new Error(t('Geçersiz sohbet.', 'Invalid chat.'));
  return id;
}

export async function listChatThreads(): Promise<ChatThreadDTO[]> {
  try {
    const { threads } = await apiRequest<{ threads?: ChatThreadDTO[] }>('GET', '/api/v1/chats');
    return Array.isArray(threads) ? threads : [];
  } catch (err) {
    if (err instanceof ApiError && err.status === 404) return [];
    throw err;
  }
}

export async function getChatThread(id: unknown): Promise<ChatThreadDetailDTO> {
  return apiRequest<ChatThreadDetailDTO>('GET', `/api/v1/chats/${requireId(id)}`);
}

export async function renameChatThread(id: unknown, title: unknown): Promise<string> {
  const clean = typeof title === 'string' ? title.trim().slice(0, 400) : '';
  if (!clean) throw new Error(t('Başlık boş olamaz.', 'The title can’t be empty.'));
  const res = await apiRequest<{ title: string }>('PATCH', `/api/v1/chats/${requireId(id)}`, { body: { title: clean } });
  return res.title;
}

export async function deleteChatThread(id: unknown): Promise<void> {
  await apiRequest<unknown>('DELETE', `/api/v1/chats/${requireId(id)}`);
}

export async function deleteAllChatThreads(): Promise<number> {
  const res = await apiRequest<{ deleted?: number }>('DELETE', '/api/v1/chats');
  return typeof res.deleted === 'number' ? res.deleted : 0;
}
